import React from 'react';
import { IconButton, Grid } from '@mui/material';
import { FaFacebookF, FaTelegramPlane, FaLinkedinIn, FaInstagram, FaTiktok, FaGooglePlay } from 'react-icons/fa';
import { MdPlace } from 'react-icons/md';

interface SocialMediaLinksProps {
  instagramLink?: string;
  tiktokLink?: string;
  telegramLink?: string;
  linkedInLink?: string;
  facebookLink?: string;
  placeLink?: string;
  playLink?: string;
}

const SocialMediaLinks: React.FC<SocialMediaLinksProps> = ({ facebookLink, tiktokLink, instagramLink, telegramLink, linkedInLink, placeLink, playLink }) => {
  const socialMediaLinks = [
    { icon: <FaInstagram  />, link: instagramLink },
    { icon: <FaTiktok />, link: tiktokLink },
    { icon: <FaTelegramPlane />, link: telegramLink },
    { icon: <FaLinkedinIn />, link: linkedInLink },
    { icon: <FaFacebookF />, link: facebookLink },
    { icon: <MdPlace />, link: placeLink },
    { icon: <FaGooglePlay />, link: playLink },
  ];

  return (
    <Grid container spacing={1}>
      {socialMediaLinks.map(({ icon, link  }) => (
        link &&
        <Grid item key={link}>
          <IconButton href={link} target="_blank" rel="noopener noreferrer" sx={{ color: "#fff", fontSize: "1rem", 
          '&:hover': {
            color: '#0a0a0a',
            borderColor: '#0a0a0a',
            backgroundColor: '#fff',
          }}}>
            {icon}
          </IconButton>
        </Grid>
      ))}
    </Grid>
  )
}

export default SocialMediaLinks